<template>
    <div class="customer-report">
        <div class="animated fadeIn">
            <component-header
                title="Customer Report"
                :isLoading="loading"
                :hasReload="true"
                :hasCreate="true"
                createButtonText="Download Report"
                @search-query="onSearchQuery"
                @create-press="downloadReportModal"
                @reload-data="fetchData"
            />
            <div v-if="loading" class="loading-container">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                />
            </div>
            <div v-else>
                <b-card class="card-wrap" border-variant="info">
                    <div class="mt-2">
                        <div class="table-wrapper">
                            <b-table
                                class="customer-table"
                                :dark="dark"
                                :hover="hover"
                                :striped="striped"
                                :bordered="bordered"
                                :small="small"
                                :fixed="fixed"
                                responsive
                                id="my-table"
                                :current-page="currentPage"
                                :per-page="perPage"
                                :items="CustomerReportList"
                                :filter="filter"
                                thead-class="header"
                                :fields="Columns"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                            >
                            </b-table>
                        </div>
                    </div>
                    <div class="pagination-wrapper">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="CustomerReportList.length"
                            aria-controls="my-table"
                            prev-text="Prev"
                            next-text="Next"
                            hide-goto-end-buttons
                        ></b-pagination>
                    </div>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import { exportFields } from "@/shared/constants/customer";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "customer",
    components: {
        ComponentHeader,
        AtomSpinner,
    },
    data: () => {
        return {
            customerData: [],
            exportFields: exportFields,
            filter: "",
            loading: false,
            totalCount: 0,
            perPage: 10,
            sortBy: "createdAt",
            sortDesc: true,
            hover: true,
            striped: false,
            currentPage: 1,
            fixed: false,
            small: false,
            dark: false,
            bordered: true,
            reportCount: "",
            defaultValue: "",
            Columns: [
                {
                    key: "customerNo",
                },
                {
                    key: "fullName",
                    label: "Name",
                },
                {
                    key: "phone",
                },
                {
                    key: "category",
                },
            ],
        };
    },
    computed: {
        CustomerReportList() {
            let data = this.$store.getters["customer/GetCustomerExportList"];
            let reportList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.forEach((obj) => {
                    reportList.push({
                        customerNo: obj && obj.customerNo,
                        fullName:
                            obj && obj.name
                                ? `${obj.name.first || ""} ${obj.name.last || ""}`.trim()
                                : "",
                        phone:
                            obj &&
                            obj.authentication &&
                            obj.authentication.phone,
                        category: obj && obj.category,
                        createdAt: obj && obj.createdAt,
                        ...obj,
                    });
                });
                return reportList;
            }
            return [];
        },
    },
    methods: {
        onSearchQuery(value) {
            this.filter = value;
        },
        async fetchData() {
            this.loading = true;
            try {
                await this.$store.dispatch("customer/fetchCustomerExport", {
                    page: 1,
                    limit: 500,
                });
            } catch (error) {
                console.error("Failed to fetch customer report:", error);
                const msg =
                    typeof error?.message === "string"
                        ? error.message
                        : error?.message?.message ||
                          "Failed to load customer report";
                this.$toasted?.error(msg);
            } finally {
                this.loading = false;
            }
        },
        downloadReportModal() {
            this.$swal({
                title: "Number of Reports",
                type: "question",
                html: `
         <input id="swal-input" class="swal2-input" style="max-width: 20em" type="number" min="1" placeholder="Enter the number of reports">
        `,
                showCancelButton: true,
                confirmButtonText: "Download",
                focusConfirm: false,
                cancelButtonText: "Cancel",
                reverseButtons: true,
                cancelButtonColor: "#d33",
                preConfirm: () => {
                    const reportCount = this.$swal
                        .getPopup()
                        .querySelector("#swal-input").value;
                    if (!reportCount || reportCount < 1) {
                        this.$swal.showValidationMessage(
                            "Please enter a valid number of reports",
                        );
                        return null;
                    }
                    return reportCount;
                },
            }).then((result) => {
                if (result.value != null) {
                    const reportCount = parseInt(result.value, 10);
                    this.downloadReport(reportCount);
                }
            });
        },
        async downloadReport(reportCount) {
            this.startDownload();
            try {
                const res = await this.$store.dispatch(
                    "customer/fetchCustomerExport",
                    {
                        page: 1,
                        limit: reportCount,
                    },
                );
                if (res?.status === 1 && res?.response) {
                    this.totalCount = res.meta?.total;
                    const array = this.getProcessedJson(
                        res.response,
                        exportFields,
                    );
                    await this.exportAsCSV(array, "customers");
                    this.finishDownload();
                } else {
                    this.$toasted?.clear();
                    this.$toasted?.error("Failed to download report");
                }
            } catch (error) {
                console.error("Download report failed:", error);
                this.$toasted?.clear();
                const msg =
                    typeof error?.message === "string"
                        ? error.message
                        : error?.message?.message ||
                          "Failed to download report";
                this.$toasted?.error(msg);
            }
        },
        getProcessedJson(data, header) {
            let keys = this.getKeys(data, header);
            let newData = [];
            let _self = this;
            data.map(function (item, index) {
                let newItem = {};
                for (let label in keys) {
                    let property = keys[label];
                    newItem[label] = _self.getValue(property, item);
                }
                newData.push(newItem);
            });
            return newData;
        },
        getValue(key, item) {
            const field = typeof key !== "object" ? key : key.field;
            let indexes = typeof field !== "string" ? [] : field.split(".");
            let value = this.defaultValue;
            if (!field) value = item;
            else if (indexes.length > 1)
                value = this.getValueFromNestedItem(item, indexes);
            else value = this.parseValue(item[field]);
            if (Object.prototype.hasOwnProperty.call(key, "callback"))
                value = this.getValueFromCallback(value, key.callback);
            return value;
        },
        getKeys(data, header) {
            if (header) {
                return header;
            }
            let keys = {};
            for (let key in data[0]) {
                keys[key] = key;
            }
            return keys;
        },
        getValueFromCallback(item, callback) {
            if (typeof callback !== "function") return this.defaultValue;
            const value = callback(item);
            return this.parseValue(value);
        },
        getValueFromNestedItem(item, indexes) {
            let nestedItem = item;
            for (let index of indexes) {
                if (nestedItem) nestedItem = nestedItem[index];
            }
            return this.parseValue(nestedItem);
        },
        parseValue(value) {
            return value || value === 0 || typeof value === "boolean"
                ? value
                : "";
        },
        startDownload() {
            this.$toasted.info("Downloading..");
        },
        finishDownload() {
            this.$toasted.clear();
            this.$toasted.success("Report downloaded");
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>
<style scoped>
.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 300px;
}

.table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.customer-table {
    border-radius: 12px;
}

.pagination-wrapper {
    float: right;
    margin-top: 1rem;
}

@media (max-width: 576px) {
    .pagination-wrapper {
        float: none;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .table-wrapper {
        margin: 0 -15px;
    }
}
</style>
